import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import logger from './shared/services/logging/logger';
import { initRum } from './utils/rum';

initRum(); // Initialise AWS RUM before rendering

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker for offline support and faster repeat loads
serviceWorkerRegistration.register({
  onUpdate: () => {
    // Do NOT force-activate here. serviceWorkerRegistration dispatches
    // 'swUpdateAvailable', which surfaces the "Update Now / Later" bar so the
    // user reloads when they're ready — never mid-run or mid-save.
    logger.info('New app version detected, awaiting user confirmation');
  },
  onSuccess: () => {
    logger.info('App content cached for offline use');
  },
});

reportWebVitals();
